module.exports = "<div class=\"sb-content-container\">\n    <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/unit/unit-authentication-google.html
// module id = 628
// module chunks = 0